<template>
    <div class="series-container">
        <ModuleTitle :caption="series.caption" :text="series.desc"></ModuleTitle>
        <SubSeries v-for="(item, index) in series.subSeries" :key="index" :sub-series="item" :slug="series.slug"></SubSeries>
        <a :href="'/collections/' + series.slug" onclick="return false">
            <b-button class="btn dark" v-if="series.btn"  @click="goToPage(series.slug)">{{series.btn.text}}</b-button>
        </a>
    </div>
</template>

<script>
    import ModuleTitle from '../../common/ModuleTitle'
    import SubSeries from './SubSeries'

    export default {
        name: 'seriesListItem',
        props: {
            series: Object,
        },
        components: {
            ModuleTitle,
            SubSeries
        },
        methods: {
            goToPage(slug) {
                this.$router.push({
                    path: 'collections/' + slug
                })
                document.scrollingElement.scrollTop = 0
            }
        },
    }
</script>

<style lang="less" scoped>
    @import "../../../assets/style/var";

    .en {
        .series-container /deep/ .title {

            .module-title {
                font-size: 26px !important;
            }

            .module-sub-title {
                margin-top: 15px !important;
            }
        }
    }

    .btn {
        margin-top: 80px;
    }

    .series-container {
        &:nth-child(n+3) {
            /deep/ .title {
                padding-top: 150px !important;
            }
        }
    }

    .series-container /deep/ .title {

        .module-title {
            font-size: 28px !important;
            line-height: 54px !important;
            font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
        }

        .module-sub-title {
            margin-top: 15px !important;
        }
    }

</style>
